module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av332-3d48b4242116f085be139ae04b4321ec.jpg";